export default __webpack_public_path__ + "static/media/Birds.92f81efe.png";